if (typeof module != 'undefined' && typeof require == 'function') {
    module.exports = require('./fittURL.js');
}


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-url/index.js
// module id = 773
// module chunks = 0